import { createStackNavigator } from '@react-navigation/stack';
import { TabNavigationParamList } from './TabNavigator';

// Tab navigator kills scroll on web version, we want it invisible there so a stack nav works fine
const { Navigator, Screen } = createStackNavigator<TabNavigationParamList>();

export { Navigator, Screen };
